export function Loader() {
  return (
        <div className="fixed inset-0 flex items-center justify-center bg-white/50 z-50">
            <div className="w-10 h-10 border-4 border-zinc-950 border-t-transparent rounded-full animate-spin"></div>
            <span className="ml-3 text-sm text-gray-700 dark:text-white">Loading...</span>
        </div>
  )
}